import React, { memo } from 'react';
import { View, StyleSheet, TouchableOpacity, Alert } from 'react-native';
import Text from 'design-system/Text';
import Logo from 'design-system/Logo';
import Spacer from 'design-system/Spacer';
import { IconTrash } from 'design-system/icons';
import { rem, hitSlop } from 'design-system/values';
import useColors from 'hooks/useColors';
import { useStockMeta } from '../hooks/selectors';
import { ROW_ITEM_VERTICAL_PADDING, ROW_ITEM_HORIZONTAL_PADDING } from '../constants';
import useAddRemoveSymbolFromWatchList from '../hooks/useAddRemoveSymbolFromWatchList';
const EditWatchListStockItem = ({ data, watchListId }) => {
    const stockCache = useStockMeta(data.id);
    const [, , removeSymbolFromWatchList] = useAddRemoveSymbolFromWatchList(watchListId);
    const onDeletePress = () => {
        Alert.alert('Remove the stock', `Are you sure you want to remove this stock from this list?`, [
            { style: 'cancel', text: 'Cancel' },
            {
                text: 'Delete',
                style: 'destructive',
                onPress: async () => {
                    if (data.symbol) {
                        removeSymbolFromWatchList(data.symbol, data.id);
                    }
                },
            },
        ]);
    };
    const colors = useColors();
    return (<View style={styles.container}>
      <Logo R44 uri={stockCache?.iconUrl} resizeMode="contain"/>
      <Spacer w={16}/>
      <View style={styles.flex}>
        <Text Text-16 flex style={styles.stockName} numberOfLines={1}>
          {data.name}
        </Text>
        {!!data.symbol && <Text TextThin-14 Gray flex>{`$${data.symbol}`}</Text>}
      </View>
      <TouchableOpacity onPress={onDeletePress} hitSlop={hitSlop}>
        <IconTrash gradientColors={[colors.text.primary, colors.text.primary]}/>
      </TouchableOpacity>
    </View>);
};
const styles = StyleSheet.create({
    container: {
        flexDirection: 'row',
        alignItems: 'center',
        paddingHorizontal: rem(ROW_ITEM_HORIZONTAL_PADDING),
        paddingVertical: rem(ROW_ITEM_VERTICAL_PADDING),
    },
    stockName: {
        marginRight: rem(16),
    },
    flex: {
        flex: 1,
    },
});
export default memo(EditWatchListStockItem);
